import { render, staticRenderFns } from "./EmployeeStatusesManager.vue?vue&type=template&id=62cfa5ca"
import script from "./EmployeeStatusesManager.vue?vue&type=script&lang=js"
export * from "./EmployeeStatusesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports